module.exports = __webpack_public_path__ + "static/img/icon3-7.76d03a1f.png";